import { render, staticRenderFns } from "./paySuccess.vue?vue&type=template&id=225c834c"
import script from "./paySuccess.vue?vue&type=script&lang=js"
export * from "./paySuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports